<template>
    <AdminPanelTemplate>
        <template #breadcrumbs>
            <Breadcrumbs :items="[{ title: 'Payouts', to: useRoute().build(Payout.routes().index) }, { title: 'Payout Details' }]" />
        </template>
        <template #content>
            <v-card class="ma-3">
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12" sm="4" xl="2">
                                <ReadOnlyTextField :value="data.status" label="Status" />
                            </v-col>
                            <v-col cols="12" sm="4" xl="2">
                                <ReadOnlyTextField :value="data.amount" label="Amount" />
                            </v-col>
                            <v-col cols="12" sm="4" xl="2">
                                <ReadOnlyTextField :value="data.price" label="Price/tCO2e" />
                            </v-col>
                            <v-col cols="12" sm="4" xl="2">
                                <ReadOnlyTextField :value="data.currency" label="Currency" />
                            </v-col>
                            <v-col cols="12" sm="4" xl="2">
                                <ReadOnlyTextField :value="data.note" label="Note" />
                            </v-col>
                            <v-col cols="12" sm="4" xl="2">
                                <ReadOnlyTextField :value="data.owner?.data.name ?? '—'" label="Owner" />
                            </v-col>
                            <v-col cols="12" sm="4" xl="2">
                                <ReadOnlyTextField :value="data.bundle?.data.name" label="Payout Event" />
                            </v-col>
                            <v-col v-if="data.bundle?.data" cols="12" sm="4" xl="2">
                                <ReadOnlyTextField :value="data.bundle.data.status" label="PE Status" />
                            </v-col>
                            <v-col v-if="data.bundle?.data" cols="12" sm="4" xl="2">
                                <ReadOnlyDateTextField :date="data.bundle.data.date" label="PE Date" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <GenericActionDialog confirm-btn-text="Update" title="Edit Payout" :disabled="false" @confirm="confirm($event)">
                        <template #activator="{ props: activatorProps }">
                            <v-btn v-bind="activatorProps" :loading="processing">Edit</v-btn>
                        </template>
                        <template #body>
                            <UpdatePayoutDialog :item="data" />
                        </template>
                    </GenericActionDialog>
                </v-card-actions>
            </v-card>
        </template>
    </AdminPanelTemplate>
</template>

<script setup lang="ts">
import { Payout } from '@app/purchase/payout/models/Payout';
import { useRoute } from '@shared/composables/useRoute';
import { useSubmitForm } from '@shared/composables/data-table/useSubmitForm.ts';

const page = Payout.routes().show.page;
const data = computed(() => page.props.data);
const { confirm, processing } = useSubmitForm();
</script>
